import { render, staticRenderFns } from "./productKesehatan.vue?vue&type=template&id=5edf0866&"
import script from "./productKesehatan.vue?vue&type=script&lang=ts&"
export * from "./productKesehatan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports